/* src/components/create-update-tender-manager-modal/create-update-tender-manager-modal.component.scss */
:host {
  display: block;
}
.company-name {
  display: table;
  width: 100%;
}
.company-name > div {
  display: table-cell;
  padding-bottom: var(--vwui-size-spacing-sm);
}
.company-name__options {
  width: 2px;
  white-space: nowrap;
  padding-left: var(--vwui-size-spacing-xs);
}
/*# sourceMappingURL=create-update-tender-manager-modal.component-WZRB3ZOC.css.map */
